import { UserModel } from './../../../../shared/models/user.model';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { ModalService } from 'src/app/shared/services/utils/modal.service';
import { InsuredReportService } from '../../service/insured-report.service';
import { ConcurrentModel } from 'src/app/shared/models/concurrent-report.model';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-concurrent-report',
  templateUrl: './concurrent-report.component.html',
  styleUrls: ['./concurrent-report.component.scss']
})
export class ConcurrentReportComponent implements OnInit {

  @ViewChild('refNo') refInput: ElementRef;

  inputForm: FormGroup;
  isShowResult: boolean = false;
  isSpinning: boolean = false;
  isVisible: boolean = false;
  titleText: '';
  userData: UserModel;
  disableSearch: boolean = false;

  constructor(
    private router: Router,
    private fb: FormBuilder,
    public modalService: ModalService,
    public insuredReportService: InsuredReportService,
    public translate: TranslateService,

  ) { 
    setTimeout(() => { // this will make the execution after the above boolean has changed
      if (this.refInput != undefined) {
        this.refInput.nativeElement.focus();
      }
    }, 300);
  }

  ngOnInit() {
    this.buildForm();
  }

  buildForm(): void {
    this.inputForm = this.fb.group({
      claimNumber: this.fb.control('', [Validators.required, Validators.minLength(10)])
    });
  }

  get claimNumberValifation() { return this.inputForm.get('claimNumber'); }

  searchInsuredReport(): void {
    for (const key in this.inputForm.controls) {
      this.inputForm.controls[key].markAsDirty();
      this.inputForm.controls[key].updateValueAndValidity();
    }
    if (this.inputForm.valid) {
      this.isSpinning = true;
      this.inputForm.controls.claimNumber.value;
      this.userData = JSON.parse(sessionStorage.getItem('user_detail'));
      const params = {
        sectionCode: this.inputForm.controls.claimNumber.value.slice(0, 2),
        orderNo: this.inputForm.controls.claimNumber.value.slice(2, 10),
        hospCode: this.userData.customer.hosCode
      };
      this.insuredReportService.searchConcurrent(params).subscribe((res: any) => {
        if (res.status.code === 200) {
          const data: ConcurrentModel = res.value.detail;
          sessionStorage.setItem('concurrunt', JSON.stringify(data));
          sessionStorage.setItem('referenceNo', JSON.stringify(this.inputForm.controls.claimNumber.value));
          this.router.navigate(['/home/concurrent-report/result']);
          this.isShowResult = true;
          this.disableSearch = true;
          this.isSpinning = false;
        } else {
          this.isSpinning = false;
          let alertText: any;
          if (this.translate.currentLang == 'th') {
            alertText = {
              R0051: "เป็นเลขเรื่องสินไหมของโรงพยาบาลอื่น",
              R0052: "ไม่พบเลขเรื่องสินไหม"
            }
          } else {
            alertText = {
              "R0051": "It is the claim number of other hospitals.",
              "R0052": "Claim number not found."
            }
          }
          if (res.status.code === "404") {
            this.modalService.error(alertText.R0052, '');
          }
          else if (res.status.code === "204") {
            this.modalService.error(alertText.R0051, '');
          }else{
            this.isSpinning = false;
          }
        }
      }, err => {
        console.log("error -> ", err);
        this.isSpinning = false;
      });
    }
  }

  clearData(): void {
    this.inputForm.get('claimNumber')!.reset();
    this.isShowResult = false;
    this.disableSearch = false;
  }

  refreshPage(){
    this.buildForm();
    this.disableSearch = false;
    setTimeout(() => { // this will make the execution after the above boolean has changed
      if (this.refInput != undefined) {
        this.refInput.nativeElement.focus();
      }
    }, 300);

  }

}
